import { render, staticRenderFns } from "./AboutAdtasukaru.vue?vue&type=template&id=1bfee8e6&scoped=true&"
import script from "./AboutAdtasukaru.vue?vue&type=script&lang=js&"
export * from "./AboutAdtasukaru.vue?vue&type=script&lang=js&"
import style0 from "./AboutAdtasukaru.vue?vue&type=style&index=0&id=1bfee8e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfee8e6",
  null
  
)

export default component.exports